



import {Component, Prop, Vue} from 'vue-property-decorator';
import SvgRender from "@/components/Atoms/SvgRender/SvgRender.vue";
import {BABY} from "@/constants";

@Component({
  components: {
    SvgRender
  }
})
export default class MainFooter extends Vue {
  @Prop(String) currentRoute!: string

  private getCurrentBaby(): any {
    return localStorage.getItem(BABY.SELECTED) || ''
  }

  private get activeHomeIcon(): string {
    return this.currentRoute == 'routes.home' ? 'active' : ''
  }

  private get activeGrowTreeIcon(): string {
    return this.currentRoute == 'routes.growTree' ? 'active' : ''
  }

  private get activeAlbumIcon(): string {
    return this.currentRoute == 'routes.album' ? 'active' : ''
  }

  private get activeSearchIcon(): string {
    return this.currentRoute == 'routes.search' ? 'active' : ''
  }

  private onClickHomeIcon() {
    this.$router.push({name: 'routes.home'})
  }

  private onClickGrowTreeIcon() {
    const babyId = this.getCurrentBaby()
    this.$router.push({name: 'routes.growTree', params: {id: babyId}})
  }

  private onClickAlbumIcon() {
    const babyId = this.getCurrentBaby()
    this.$router.push({name: 'routes.album', params: {id: babyId}})
  }

  private onClickSearchIcon() {
    this.$router.push({name: 'routes.search'})
  }
}
